<main role="main">
  <div class="background" [style.background-image]="clientBackgroundUrl">
    <router-outlet></router-outlet>
  </div>
</main>
